<template>
  <modalWindow v-if="importing" @close="importing=false;$parent.getUsers();" width="600">
    <div class="titlebar">Gebruikers importeren</div>
    <form @submit.prevent class="inset">
      <template v-if="users.length <= 0">
        <input type=file accept="text/csv" ref="file" placeholder="file">
        <input type=submit @click="testImport" value="Test file">
      </template>
      <template v-else>
        <span class="form-notice">
          Gevonden gebruikers: {{users.length}}
          <br />
          Ge-importeerde gebruikers: {{formatPrice(imports, true)}}
        </span>
        <br><br>
        <table>
          <thead class="table-legend">
            <tr>
              <th></th>
              <th>Naam</th>
              <th>Gebruikersnaam</th>
              <th>E-mail</th>
              <th>Portefeuilles</th>
              <th>Status</th>
            </tr>
          </thead>
          <tr v-for="(user, index) in users" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{user.name}}</td>
            <td>{{user.username}} <span v-if="user.password">*</span></td>
            <td>{{user.email}}</td>
            <td>{{uniq(user.port).join(', ')}}</td>
            <td v-if="user.status==1">Geimporteerd</td>
            <td v-else-if="user.status==-1">Error: {{ user.error }}</td>
            <td v-else>In de wacht</td>
          </tr>
        </table>
        <span>* has password imported</span>
        <input v-if="!imported" type=submit @click="doImport" value="Importeer gebruikers">
        <input v-if="!imported" type=submit @click="users=[]" value="Annuleren">
        <input v-if="imported" type=submit @click="users=[];imported=false" value="New import">
      </template>
    </form>
  </modalWindow>
</template>

<script>
import { countBy, forEach, uniq } from 'lodash-es';

export default {
  name: 'ImportUsers',
  data() {
    return {
      importing: false,
      imported: false,
      users: [],
    };
  },
  computed: {
    imports() {
      const done = countBy(this.users, 'status');
      return done[1] ? done[1] : 0;
    },
  },
  methods: {
    uniq,
    async doImport() {
      this.imported = true;
      forEach(this.users, (user, index) => {
        setTimeout(() => {
          this.sdk.addUser(
            user.name,
            user.username,
            user.email,
            0,
            user.password,
            user.salt,
            (response) => {
              if (response.status === 200) {
                // each port
                forEach(uniq(user.port), (port) => {
                  this.sdk.addUserPort(
                    response.data.user,
                    port,
                  );
                });
                this.users[index].status = 1;
              } else {
                this.users[index].status = -1;
                this.users[index].error = response.data.message;
              }
            },
          );
        }, (index * 1000) + 1);
      });
    },
    testImport() {
      const reader = new FileReader();
      reader.onload = () => {
        this.processData(reader.result);
      };
      reader.readAsText(this.$refs.file.files[0]);
    },
    processData(allText) {
      const allTextLines = allText.split(/\r\n|\n/);
      const headers = allTextLines[0].split(';');
      this.users = [];
      for (let i = 1; i < allTextLines.length; i += 1) {
        const data = allTextLines[i].split(';');
        if (data.length === headers.length) {
          const tarr = { status: 0 };
          for (let j = 0; j < headers.length; j += 1) {
            if (headers[j] === 'port') {
              if (!tarr[headers[j]]) {
                tarr[headers[j]] = [];
              }
              if (data[j]) {
                tarr[headers[j]].push(data[j]);
              }
            } else {
              tarr[headers[j]] = data[j];
            }
          }
          this.users.push(tarr);
        }
      }
    },
  },
};
</script>

<style scoped>
.content {
  max-width: 800px;
  overflow-y: scroll !important;
  max-height: 800px;
}
</style>
